import { render, staticRenderFns } from "./motores_inversores_bombas.vue?vue&type=template&id=27d4a5ac"
import script from "./motores_inversores_bombas.vue?vue&type=script&lang=js"
export * from "./motores_inversores_bombas.vue?vue&type=script&lang=js"
import style0 from "./motores_inversores_bombas.vue?vue&type=style&index=0&id=27d4a5ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports